import { useInView } from "../hooks/useInView";
import { BookOpen, ArrowRight } from "lucide-react";

const BLOGS = [
  {
    title: "Your Daily Meal Plan",
    desc: "Discover a balanced meal plan for better health.",
    tag: "Nutrition",
  },
  {
    title: "Food as Medicine",
    desc: "Explore the healing powers of natural foods.",
    tag: "Wellness",
  },
  {
    title: "Everyday Diet Plan",
    desc: "Follow a diet plan that supports your health goals.",
    tag: "Lifestyle",
  },
];

function BlogCard({ blog, index }) {
  const [ref, inView] = useInView(0.1);
  return (
    <div
      ref={ref}
      className="bg-white rounded-2xl overflow-hidden shadow-sm border border-green-50 hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group cursor-pointer flex flex-col"
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? "translateY(0)" : "translateY(30px)",
        transition: `opacity 0.5s ease ${index * 0.1}s, transform 0.5s ease ${index * 0.1}s, box-shadow 0.3s`,
      }}
    >
      {/* Decorative banner */}
      <div className="h-40 bg-gradient-to-br from-primary to-accent flex items-center justify-center relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <svg viewBox="0 0 200 120" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
            <path d="M100 10 Q140 30 130 70 Q120 100 100 110 Q80 100 70 70 Q60 30 100 10Z" fill="white"/>
            <path d="M30 50 Q60 60 70 80 Q50 90 30 80 Q10 70 30 50Z" fill="white"/>
            <path d="M160 40 Q180 55 170 75 Q155 85 145 70 Q140 55 160 40Z" fill="white"/>
          </svg>
        </div>
        <BookOpen className="w-12 h-12 text-white/80 relative z-10 group-hover:scale-110 transition-transform duration-300" />
        <span className="absolute top-3 left-3 bg-white/20 text-white text-xs font-semibold px-2.5 py-1 rounded-full backdrop-blur-sm">
          {blog.tag}
        </span>
      </div>

      <div className="p-5 flex flex-col flex-1">
        <h3 className="font-display font-semibold text-darktext text-lg mb-2 group-hover:text-primary transition-colors">
          {blog.title}
        </h3>
        <p className="text-gray-600 text-sm leading-relaxed flex-1">{blog.desc}</p>
        <div className="mt-4 flex items-center gap-1 text-primary text-sm font-medium group-hover:gap-2.5 transition-all">
          Read More <ArrowRight className="w-4 h-4" />
        </div>
      </div>
    </div>
  );
}

export default function Blogs() {
  const [headRef, headInView] = useInView(0.2);

  return (
    <section id="blogs" className="py-20 bg-lightbg">
      <div className="max-w-7xl mx-auto px-4">
        <div
          ref={headRef}
          className="text-center mb-12"
          style={{
            opacity: headInView ? 1 : 0,
            transform: headInView ? "translateY(0)" : "translateY(25px)",
            transition: "opacity 0.6s ease, transform 0.6s ease",
          }}
        >
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary mb-3">
            Health Insights
          </span>
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-darktext mb-4">
            Blogs
          </h2>
          <p className="text-gray-600 max-w-xl mx-auto text-base">
            Explore articles on wellness, nutrition, and natural healing.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {BLOGS.map((b, i) => (
            <BlogCard key={b.title} blog={b} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
